var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 4L4 21M21 21L4 4L21 21Z",
  stroke: "white",
  strokeWidth: 2.04167,
  strokeLinecap: "round"
})));
export { SvgCross as ReactComponent };
export default __webpack_public_path__ + "assets/icons/cross.f0c285.svg";